export default "__VITE_ASSET__vNEaKvve__"